import { record } from 'fp-ts';
import { values } from '@mews/fp';

import { DEFAULT_ADULT_COUNT } from '../../constants';
import { ApplicationState } from '../../types';
import { WithServiceId } from '../../types/selectors/selectorPropTypes';
import { getEnterpriseDatesOccupancy } from '../../views/dates/slices/selectors';
import { isDefaultAgeCategory } from '../entities/ageCategories/selectors';
import { getServiceEnterpriseId } from '../entities/services/selectors';
import { getInitialOccupancyData } from './selectors';

export const getCategoriesOccupancyData = (state: ApplicationState, { serviceId }: WithServiceId) => {
    const enterpriseId = getServiceEnterpriseId(state, { serviceId });

    const datesOccupancy = enterpriseId != null ? getEnterpriseDatesOccupancy(state, { enterpriseId }) : null;

    const occupancyData =
        datesOccupancy != null && !record.isEmpty(datesOccupancy)
            ? values(datesOccupancy)
            : getInitialOccupancyData(state, { serviceId });
    /**
     * This part checks if occupancy personCounts are 0, if so we change age category count to 2, as agreed
     */
    if (occupancyData.every((occupancy) => occupancy.personCount === 0)) {
        return occupancyData.map(({ ageCategoryId }) => {
            if (isDefaultAgeCategory(state, { ageCategoryId })) {
                return { ageCategoryId, personCount: DEFAULT_ADULT_COUNT };
            }
            return { ageCategoryId, personCount: 0 };
        });
    }
    return occupancyData;
};
